import { useState, useEffect } from "react";
import { apiConstants, getGeneric } from '../../common/constants'
import * as React from 'react'
import { useSnackbar } from "notistack";
import { Box, Typography } from '@mui/material';
import Loader from "../../common/Loader";
import PageTitle from "../../common/PageTitle";
import { getMerchant } from "../../helpers/ReduxHelpers";
import ChannelOrderVerification from "./channelOrderWA";
import ChannelOrderAddress from "./channeOrderAddress";
import CustomerNotification from "./customerNotification";
import withLayout from "../../hocs/Layout";
import AutomatedNdrConfig from "./automatedNDR";
import { pageContainerSx } from '../../styles/patterns';
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography';
import { NAVY } from '../../styles/foundation/colors';


function ConfigMain() {
    const merchant = getMerchant();
    const merchantId = merchant.id ?? '';
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(0);
    const [data, setData] = useState(null);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const fetchConfig = async () => {
            setLoading(true);
            try {
                const response = await getGeneric(`${apiConstants.SYSTEM_DEFAULT_PRICING}?merchantOid=${merchantId}`);
                const data = response.data || [];
                setData(data);
            } catch (err) {
                console.error(err);
                enqueueSnackbar("Failed to fetch configuration", { variant: 'error' });
            } finally {
                setLoading(false);
            }
        };
        fetchConfig();
    }, [merchantId, reload, enqueueSnackbar]);

    return (
        <Box sx={pageContainerSx}>

            {loading && <Loader />}
            <PageTitle subTitle="Value added services to manage NDR, Whatsapp Integrations & Notifications">VAS</PageTitle>

            <AutomatedNdrConfig
                data={data}
                merchantId={merchantId}
                setReload={setReload}
            />

            <Typography sx={{ fontFamily: FONT, fontSize: SIZE.md, fontWeight: WEIGHT.semibold, color: NAVY, mt: 3, mb: 1.5 }}>
                Webstore Integrations
            </Typography>

            <ChannelOrderVerification
                merchantId={merchantId}
                setReload={setReload}
                data={data} />

            <ChannelOrderAddress
                merchantId={merchantId}
                setReload={setReload}
                data={data} />

            <Typography sx={{ fontFamily: FONT, fontSize: SIZE.md, fontWeight: WEIGHT.semibold, color: NAVY, mt: 3, mb: 1.5 }}>
                Customer Notifications
            </Typography>

            <CustomerNotification
                merchantId={merchantId}
                setReload={setReload}
                data={data} />

        </Box>
    );
}

export default withLayout(ConfigMain);